<div class="dtf-accountdetails">

<!-- <h1 mat-dialog-title>{{ 'LoginModal.AccountRegistration' | translate }}</h1> -->
<mat-dialog-content>
  @if (this.payoffdialog ==='one') {
    <h2><b>Payoff</b></h2>
    <p>Select when you want to pay</p>
  } 
  @if (this.payoffdialog ==='two') {
    <h2><b>Bank Profile Warning</b></h2>
    <p>Based on the information provided, the bank account from which the debit is to be made is a commercial account and the name on the bank account is different from the name on the account with Daimler Truck Financial Services. By clicking on "I agree” below, you acknowledge and agree that you are authorized without limitation to initiate electronic debit entries from the bank account at the times and in the amounts indicated and you will provide written evidence of such authorization upon request.</p>
  } 
  @if (this.payoffdialog ==='three') {
    <h2><b>AutoPay Authorization</b></h2>
    <p>Please read and accept the agreement below.</p>
    <p>Upon acceptance by Daimler Truck Financial Services USA LLC, its successors and assigns ("Daimler Truck Financial Services"), of this authorization and a properly voided check/draft, preprinted with all the account holder name(s) and address, Daimler Truck Financial Services is authorized by the account holder ("I", "me" or "my") to initiate electronic debit entries or effect a charge by any other commercially accepted means to my account held at the financial institution listed below for the amount of the monthly payment described in my lease or retail installment sale contract with Daimler Truck Financial Services ("Agreement"). I authorize and request the financial institution listed on this form to honor such debit entries to the contract number listed on this form. In addition, this authorization includes all other amounts due pursuant to the terms of the Agreement, which may vary from the amount of the regularly scheduled payment to an amount exceeding the regularly scheduled payment by $100. I understand that Daimler Truck Financial Services will notify me of any changes in the dollar amount to be debited from my account where the debited amount will exceed the regularly scheduled payment by more than $100. This authorization will remain in force until either Daimler Truck Financial Services or I have received reasonable and advance written notice of cancellation from the other party or until satisfaction in full of all my obligations under the Agreement. If my payment due date falls on a bank holiday or a weekend, my payment will be deducted on the next business day after the due date. If my account is a lease, my payment will be deducted on the scheduled due date and will continue up to and including the last lease payment due on my account. Otherwise, payments will be deducted on the scheduled due date until the next to last payment due on my account; I will receive a separate bill for the last payment. I may receive a separate bill for charges associated with the return of my vehicle (i.e., excess wear and use, excess mileage, etc.).</p>
  } 
  @if (this.payoffdialog ==='four') {
    <p>Your Daimler Truck Financial Services Auto Pay profile has been successfully submitted and saved. This profile will be used for all your future Auto Pay transactions for this account.</p>
    <p>Please review the Auto Pay effective date per account; If you have a due date before then, you must make the payment manually.</p>
    <div *ngFor="let contract of contractNumberList; first as isFirst;">
      <div class="listcolumn_popup">
        @if(isFirst){
          <h4>Contract Number(s)</h4>
        }
        <p>{{contract.contractNumber}}</p>
      </div>
      <div class="listcolumn_popup">
        @if(isFirst){
          <h4>Effective Date</h4>
        }
        <p>{{contract.effectiveDate}}</p>
      </div>
    </div>
  } 
  @if (this.payoffdialog ==='error') {
    <div>
      <mat-dialog-title>
        <h2><b>Error</b></h2>
      </mat-dialog-title>
      <br>
      <p><b>{{errorMessage}}</b></p>
    </div>
  }
  @if (this.payoffdialog ==='six') {
    <h2><b>AutoPay Termination Confirmation</b></h2>
    <p>This action will stop Auto Pay withdrawls on the selected accounts. Terminations will take effect five business days after this request is submitted. If you have a due date within this window, Auto Pay will be disabled on the following due date.</p>
  
  }
  @if ((!this.tableLoaded) && this.payoffdialog ==='seven') {
    <div class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
      <div class="demo-container">
        <span>Retrieving Addresses</span>
        <div class="progress-bar">
          <div class="progress-bar-value"></div>
        </div>
      </div>
      <br>
    </div>
  }
 
  @if (this.payoffdialog ==='seven' && this.tableLoaded && statusMessage ==='SUCCESS') {

    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      @for(column of initColumns;track column){

      <ng-container matColumnDef="{{column.name}}">
          <th mat-header-cell *matHeaderCellDef> {{column.display}} </th>
          <mat-cell *matCellDef="let element">
            @if(column.dispFormat=='Address'){
              <br>
              <span>{{element.streetAddress1}} {{element.streetAddress2}}  {{element.city}} {{element.state}} {{element.postalCode}}</span>
            } 
            @if(column.dispFormat==''){
              <span>
                <br>
                <button mat-dialog-close  type="submit" class="mbfs-button" (click)="useAddress(element)">Use This Address</button>
              </span> 
            }
          </mat-cell>
      </ng-container>
    }
    <ng-container matColumnDef="vertexAddressResponse">
        <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
          [attr.colspan]="displayedColumns.length">
        </mat-cell>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>    
    </table>
    
<br>
    <button mat-button (click)="closeDialog('invalid')">Close</button>
}

  @if(this.payoffdialog ==='seven' && this.tableLoaded){
    @if(statusMessage ==='EMPTY'){
      <h2><b>Address is Cleansed</b></h2><br>
      <button mat-button (click)="closeDialog('invalid')">Close</button>
     }
     @if(statusMessage !=='SUCCESS'){
      <h2><b>Error</b></h2><br>
      <p>There is an issue with the address provided</p><br>
    <button mat-button (click)="closeDialog('invalid')">Close</button>
     }
  }
</mat-dialog-content>
<mat-dialog-actions mat-dialog-actions>
  @if (this.payoffdialog ==='error') {
  <button mat-button (click)="payoffRedirect($event)" mat-dialog-close>Cancel</button>
  <button mat-button mat-dialog-close>Continue</button>
  }
  @if (this.payoffdialog ==='one' || this.payoffdialog ==='two' || this.payoffdialog ==='three' ) {
    <button mat-button mat-dialog-close>I Agree</button>
    }
    @if (this.payoffdialog ==='four') {
      <button mat-button  (click)="payoffRedirect($event)" mat-dialog-close>I Agree</button>
      }
      @if (this.payoffdialog ==='six') {
        <button mat-button (click)="payoffRedirect($event)" mat-dialog-close>Cancel</button>
        <button mat-button mat-dialog-close>Terminate</button>
              }

</mat-dialog-actions>
</div>
